module.exports = __webpack_public_path__ + "static/media/logout.722cd7ad.svg";